<template>
    <div class="block page-choujiang" >
        <img class="cj-title pa" src="../../assets/image/n_cj2.png" alt="">
        <img class="bg" src="../../assets/image/n_cj_page_bg.png" alt="">
        <div class="jiqi">
            <!-- 顺时针位置5中奖weizhi5 -->
            <div :class="['zhuanpan', 'weizhi'+chouzhongIndex]">
                <template v-for="(item ,index) in giftList">
                    <img v-if="index<=7" :class="['p', 'pa', 'p'+(index+1)]" :src="item.img" :key="index" alt="">
                </template>
                <img class="img" src="../../assets/image/n_z.png" alt="">
            </div>
            <img class="zhizhen pa" @click="start" src="../../assets/image/n_cj_zz.png" alt="">

            <!-- <img v-if="showGift" class="gift pa" :src="chouzhong.img" alt=""> -->
            <div class="voice to">
                <!-- <img src="../../assets/image/voice.png" class="icon" alt=""> -->
                <el-carousel height="20px" direction="vertical" class="run to" :autoplay="true">
                    <el-carousel-item v-for="(item, index) in tongzhi" :key="index">
                        <div class="medium to">恭喜用户{{ item.nickName}}获得{{ item.giftName}}</div>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div class="jihui">您还有{{canRunCount}}次抽奖机会</div>
            <div class="da-ti" @click="start">开始抽奖</div>
            <!-- <div :class='"button2 button-choujiang" + (disabled?" disabled":"")' >抽奖</div> -->
            <!-- <div class='button2 button-home' @click="$router.push('/')">返回首页</div> -->
        </div>
        

        <!-- 谢谢参与,未中奖 -->
        <el-dialog
            :visible.sync="dialogNo"
            width="100%"
            custom-class='el-dialog-no-header'
            center
            :close-on-click-modal="true"
        >
            <div class="pop-box pop-box-no pr">
                <div class="title pa"></div>
                <div class="num pa"></div>
                <div class="button1 pop-btn pa" @click="close">我知道了</div>
                <div class="close pa" @click="close"></div>
            </div>
        </el-dialog>
        <!-- 抽中话费 -->
         <el-dialog
            :visible.sync="dialogHuaFei"
            width="100%"
            custom-class='el-dialog-no-header'
        >
            <div class="pop-box pr">
                <div class="title pa">恭喜您抽中</div>
                <div class="num pa">{{chouzhong.name}}</div>
                <img src="@/assets/image/n_p_huafei.png" class="tipsss tipsss-huafei pa" alt="">
                <div class="descsss pa">话费奖品将于活动结束后的次月底前充值至您注册账号所用手机号码中</div>
                <div class="button1 pop-btn pa" @click="close">提交</div>
                <div class="close pa" @click="close"></div>
            </div>
            
        </el-dialog>
        <!-- 抽中积分-->
        <el-dialog
            :visible.sync="dialogJiFen"
            width="100%"
            custom-class='el-dialog-no-header'
        >
            <div class="pop-box pr">
                <div class="title pa">恭喜您抽中</div>
                <div class="num pa">{{chouzhong.name}}</div>
                <img src="@/assets/image/n_p_jifen.png" class="tipsss tipsss-jifen pa" alt="">
                <div class="button1 pop-btn pa" @click="close">立即领取</div>
                <div class="close pa" @click="close"></div>
            </div>
            
        </el-dialog> 
        
    </div>
</template>

<script>
    // import axios from 'axios'
import api from '@/assets/js/api'
import { cookie } from '@/assets/js/utils'
    export default {
        name: "notice",
        data() {
            return {
                actId: (window && window.actId),
                canSubmitPhone: true,
                // phone: '',
                dialogNo: false, // 谢谢参与
                tongzhi: [],
                giftList: [], // 奖品列表
                prize: 8,
                showGift: false,
                disabled: false, // 不可抽奖
                chouzhong: {},
                chouzhongIndex: 0,
                canRunCount: 0, // 剩余抽奖此事
                dialogHuaFei: false,
                dialogJiFen: false,
               
            }
        },
        methods: {
            close(){
                this.dialogNo = false;
                this.dialogJiFen = false;
                this.dialogHuaFei = false;
                this.chouzhongIndex = 0;
            },
            init(){
                let self = this;
                let giftList = self.giftList;
                
                self.disabled = false;
            },
            
            getCanRunNums(){
                let self = this;
                let token = cookie.get('token'+self.actId);
                if(!token){
                    // self.onShowLoginPop();
                    self.$message({
                        message: '需要先登陆哦！'
                    })
                    return;
                }
                api({
                    method: 'canRunCount',
                    token
                })
                .then(res => {
                    let { data, code } = res && res.data;
                    if(code == 200){
                        self.canRunCount = data.canRunCount;
                    }
                })
            },
            getZhongjiang(){
                let self = this;
                api({
                    method: 'lastWinNote',

                }).then(res => {
                    let {data, code ,msg} = res && res.data;
                    if(code == 200){
                        self.tongzhi = data;
                    }else{
                        // console.log(msg)
                    }
                    
                })
            },
            
            async start(){
                let self = this;
                console.log(self.disabled)
                if(self.disabled){
                    return false;
                }

                if(Number(self.canRunCount) <= 0){
                    self.$message({
                        message: '抽奖次数已经用完了'
                    })
                    return;
                }
                self.showGift = false;
                self.disabled = true;

                let token = cookie.get('token'+self.actId);
                if(!token){
                    // self.onShowLoginPop();
                    self.$message({
                        message: '需要先登陆哦！'
                    })
                    return;
                }
                let res = await api({
                    method: 'run',
                    token
                }).catch(err => {
                    // console.log(err)
                    // self.disabled = false;

                })
                let {data, code ,msg} = res && res.data;
                // console.log(data, code ,msg)
                // code = 170;
                if(code ==200){
                    self.chouzhong = data;
                    self.canRunCount = self.chouzhong.canRunCount;
                    self.getZhongjiang(); // 小喇叭
                    self.giftList.map((item,ii) => {
                        // if(item.giftId == self.chouzhong.giftId){
                        if(item.giftId == self.chouzhong.giftId){
                            // 5
                            self.chouzhongIndex = ii + 1;
                        }
                    })
                }else{
                    self.$message({
                        message: msg || '抽奖失败'
                    })
                    return;
                }

                let tt = setTimeout(()=>{
                    clearTimeout(tt);
                    self.chouzhongIndex = 0; // 初始化转盘
                    if(self.chouzhong.winId > 0){
                        self.dialogHuaFei = !self.chouzhong.isScore;
                        self.dialogJiFen = self.chouzhong.isScore;
                    }else{
                        // 谢谢参与
                        self.dialogNo = true;


                    }
                    self.disabled = false;

                    
                }, 8000)
                
            },
            
            async getList(){
                let self = this;
                let token = cookie.get('token'+self.actId);
                if(!token){
                    // self.onShowLoginPop();
                    self.$message({
                        message: '需要先登陆哦！'
                    })
                    self.$router.push('/')
                    return;
                }
                let res = await api({
                    method: 'giftList',
                    token
                }).catch(err => {
                    // console.log(err)
                })
                let {data, code ,msg} = res && res.data;
                // console.log(data, code ,msg)
                if(code ==200){
                    self.giftList = data;
                    // console.log(data)
                }
            }
        },
        mounted() {
            let self =this;
            // self.dialogNo = 1;
            // this.dialogHuaFei = true
            self.actId = self.query && self.query.__sa || (window && window.actId);
            this.getList()
            this.getCanRunNums(); // 剩余抽奖次数
            this.getZhongjiang(); // 小喇叭

            
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import 'style.less';
</style>